import { NoParamEndpointConstructor } from 'interfaces/api.interfaces'

const baseUrl = '/data-source-fields'

interface Endpoints {
  getAll: NoParamEndpointConstructor
}

export const dataSourceFieldsEndpoints: Endpoints = {
  getAll: () => `${baseUrl}`,
}
